<template>
  <v-container>
    <v-layout column>
      <v-flex grow>
        <v-alert
          v-model="isError"
          dismissible
          type="error"
          transition="fade-transition"
        >
          {{ errMessage }}
        </v-alert>
      </v-flex>
      <v-flex>
        <h1>{{ action }} Church</h1>
      </v-flex>
      <v-flex>
        <v-form @submit="submit">
          <v-layout column>
            <v-flex>
              <v-text-field
                v-model="name"
                label="Church Name"
                required
                :error-messages="errors.name"
                id="name"
                @focus="inputFocus"
              />
              <v-text-field
                v-model="city"
                label="City"
                required
                :error-messages="errors.city"
                id="city"
                @focus="inputFocus"
              />
              <v-text-field
                v-model="state"
                label="State"
                required
                :error-messages="errors.state"
                id="state"
                @focus="inputFocus"
              />
            </v-flex>
            <v-flex xs3>
              <v-btn
                block
                type="submit"
                id="submit"
              >
                Save
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    name: null,
    city: null,
    state: null,

    isError: false,
    errMessage: null,
    errors: {
      name: null,
      city: null,
      state: null
    }
  }),
  computed: {
    churchID: function () {
      if (this.$route.params.id === 'new') {
        return null
      } else {
        return this.$route.params.id
      }
    },
    action: function () {
      if (this.churchID === null) {
        return 'Add'
      } else {
        return 'Edit'
      }
    }
  },
  mounted: function () {
    // If we're making a new church, we're done
    if (this.churchID === null) {
      return
    }

    // Otherwise, we need to load data for the church
    var _this = this
    this.axios.get('/churches/' + this.churchID)
      .then(function (res) {
        let church = res.data[0]

        _this.name = church.name
        _this.city = church.city
        _this.state = church.state
      })
      .catch(this.$root.apiErrorHandler(function (msg, errors, err) {
        // If our error is a 404, that means we got a bogus church ID value and
        // we can safely abort back to the church listing page. Otherwise, we want
        // to render our error message.
        if (err && err.response && err.response.status === 404) {
          return _this.$router.push('/admin/churches')
        } else {
          _this.errMessage = msg
          _this.isError = true
        }
      }))
  },
  methods: {
    submit: function (ev) {
      ev.preventDefault()

      var _this = this

      // Set up the proper request based on whether we're editing or creating
      let url = '/churches'
      let method = 'POST'
      if (this.churchID !== null) {
        url += '/' + this.churchID
        method = 'PUT'
      }

      this.axios.request({
        method,
        url,
        data: {
          name: this.name,
          city: this.city,
          state: this.state
        }
      })
        .then(function () {
          _this.$router.push('/admin/churches')
        })
        .catch(this.$root.apiErrorHandler(function (msg, errors) {
          _this.errMessage = msg
          _this.errors = errors
          _this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  }

}
</script>
